module.exports = __webpack_public_path__ + "static/media/medalIcon.24e7ead5.svg";